import { createReducer } from '@reduxjs/toolkit';
import type { RecentlyViewedItemState } from './state';
import initialRecentlyViewedItemState from './state';

const recentlyViewedItemReducer = createReducer<RecentlyViewedItemState>(initialRecentlyViewedItemState, () => {});

export default recentlyViewedItemReducer;
